/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentUpdateSocialVersionMutationRequest, ContentUpdateSocialVersionMutationResponse, ContentUpdateSocialVersionPathParams } from "../models/ContentUpdateSocialVersion";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { contentUpdateSocialVersion } from "../axios/contentUpdateSocialVersion";
import { useMutation } from "@tanstack/react-query";

export const contentUpdateSocialVersionMutationKey = () => ["content-ai-api", { url: '/contents/:id/social-version/:platform/update' }] as const

export type ContentUpdateSocialVersionMutationKey = ReturnType<typeof contentUpdateSocialVersionMutationKey>

/**
 * @summary Update social version before publishing
 * {@link /contents/:id/social-version/:platform/update}
 */
export function useContentUpdateSocialVersion<TContext>(options: 
{
  mutation?: UseMutationOptions<ContentUpdateSocialVersionMutationResponse, ResponseErrorConfig<Error>, {id: ContentUpdateSocialVersionPathParams["id"], platform: ContentUpdateSocialVersionPathParams["platform"], data?: ContentUpdateSocialVersionMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ContentUpdateSocialVersionMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? contentUpdateSocialVersionMutationKey()

  return useMutation<ContentUpdateSocialVersionMutationResponse, ResponseErrorConfig<Error>, {id: ContentUpdateSocialVersionPathParams["id"], platform: ContentUpdateSocialVersionPathParams["platform"], data?: ContentUpdateSocialVersionMutationRequest}, TContext>({
    mutationFn: async({ id, platform, data }) => {
      return contentUpdateSocialVersion(id, platform, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}